// extracted by mini-css-extract-plugin
var _1 = "UserDetailPreview-module__actionButton--c6hwB";
var _2 = "UserDetailPreview-module__amount--fDRwJ";
var _3 = "UserDetailPreview-module__animateUploadProgressBarWidth--WkZlZ";
var _4 = "UserDetailPreview-module__animatedBackground--tm_KF";
var _5 = "UserDetailPreview-module__avatar--PufuD";
var _6 = "UserDetailPreview-module__container--q6D6Q";
var _7 = "UserDetailPreview-module__content--DOxh7";
var _8 = "UserDetailPreview-module__editorRoot--hRwUS";
var _9 = "UserDetailPreview-module__footer--z3Rd3";
var _a = "UserDetailPreview-module__groupIcon--myKJ2";
var _b = "UserDetailPreview-module__groups--iVVaD";
var _c = "UserDetailPreview-module__header--QU80d";
var _d = "UserDetailPreview-module__headerSection--yzNkm";
var _e = "UserDetailPreview-module__identity--GFJjj";
var _f = "UserDetailPreview-module__overlayLink--_jnkS";
var _10 = "UserDetailPreview-module__posts--BkwsN";
var _11 = "UserDetailPreview-module__postsIcon--c3z5Q";
var _12 = "UserDetailPreview-module__profiles--1x7dw";
var _13 = "UserDetailPreview-module__title--ueWIH";
var _14 = "UserDetailPreview-module__topics--vOSjl";
var _15 = "UserDetailPreview-module__topicsIcon--jEWL1";
var _16 = "UserDetailPreview-module__userBadge--yfNmi";
export { _1 as "actionButton", _2 as "amount", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "avatar", _6 as "container", _7 as "content", _8 as "editorRoot", _9 as "footer", _a as "groupIcon", _b as "groups", _c as "header", _d as "headerSection", _e as "identity", _f as "overlayLink", _10 as "posts", _11 as "postsIcon", _12 as "profiles", _13 as "title", _14 as "topics", _15 as "topicsIcon", _16 as "userBadge" }
